// Centralised constants — Sacco Nutrizione (Dr. Christian Sacchetto)
export const WHATSAPP_NUMBER = "393717990344"; // +39 371 799 0344
export const WHATSAPP_DEFAULT_MSG = "Salve, vorrei avere più informazioni riguardo al servizio";
export const whatsappUrl = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg || WHATSAPP_DEFAULT_MSG)}`;

export const INSTAGRAM_URL = "https://www.instagram.com/sacconutrizione/";

export const NAV_LINKS = [
  { label: "Chi sono", href: "#chi-sono" },
  { label: "Servizi", href: "#servizi" },
  { label: "Metodo", href: "#metodo" },
  { label: "Trasformazioni", href: "#trasformazioni" },
  { label: "Recensioni", href: "#recensioni" },
  { label: "FAQ", href: "#faq" },
];
